import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import * as Enum from '../utils/enums'
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import { Loading } from '../utils/loading';
import * as Constants from '../utils/constants';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { GestioneAllegatiService } from '../services/gestione-allegati.service';
import { LoginService } from '../services/login.service';
import { IUserCheck } from '../interfaces/IUserLogin';


@Component({
  selector: 'app-app-home',
  templateUrl: './app-home.component.html',
  styleUrls: ['./app-home.component.css']
})
export class AppHomeComponent implements OnInit {

  isAggiudicatario: boolean
  isPrefetto: boolean
  isEsecutore: boolean
  isAdmin: boolean
  isAffidatario: boolean
  isReferente: boolean
  isCSE: boolean
  items: MenuItem[];
  currentPageEnum: Enum.PAGE_ENUM
  pageName: string
  userName: string
  userRole: string
  imagePath: string     //imagePath logo
  wbBaseUrl: string    // base url from Constants
  itemsManual: MenuItem[] // menu items for download manual

  @Output() onLogout: EventEmitter<any> = new EventEmitter<any>()

  PE = Enum.PAGE_ENUM   //export for html
  L = Loading           //export for html

  waitingForConnection: any

  ragSociale: string

  constructor(private translate: TranslateService,
    private gestioneAllegatiService: GestioneAllegatiService,
    private alertUtil: AlertUtil,
    private loginService: LoginService) { }

  ngOnInit() {
    this.userName = localStorage.getItem(Constants.LS_USERNAME)
    this.ragSociale = localStorage.getItem(Constants.LS_RAG_SOCIALE)
    this.wbBaseUrl = Constants.WS_BASE_URL
    this.setLogoAndStyle()
    //Set if user is aggiudicatario or esecutore
    this.isAggiudicatario = false
    this.isPrefetto = false
    this.isEsecutore = false
    this.isAdmin = false
    this.isAffidatario = false
    this.isReferente = false
    this.isCSE = false
    this.checkUserRole();
    this.setPages();
    this.setItemsManual()
    if (this.isAggiudicatario) {
      this.getAllAllegatiAndCheckNonLetti()
    }
  }

  private checkUserRole() {
    this.userRole = localStorage.getItem(Constants.LS_USER_ROLE);
    if (this.userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.PREFETTURA
      || this.userRole == Enum.USER_TYPE_ENUM.DL) {
      this.isPrefetto = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO
      || this.userRole == Enum.USER_TYPE_ENUM.GVS) {
      this.isAffidatario = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.REFERENTE) {
      this.isReferente = true;
    } else if (this.userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isCSE = true
    }
  }

  private setItemsManual() {
    this.itemsManual = [
      {
        label: "Desktop",
        icon: 'pi pi-download',
        command: () => {
          this.openManual("DESKTOP");
        }
      },
      {
        label: "APP",
        icon: 'pi pi-mobile',
        command: () => {
          this.openManual("APP");
        }
      }
    ]
  }

  /**
   * open download menu
   * @param menu 
   * @param event
   */
  openMenu(menu, event: any) {
    menu.toggle(event)
  }

  /**
   * Controllo versione app per cambio logo e relativi stili
   */
  private setLogoAndStyle() {
    this.imagePath = "./assets/images/LogoLegalileo.png";
  }

  /**
   * set pages visualized
   */
  private setPages() {
    // set default page as HOME
    this.currentPageEnum = Enum.PAGE_ENUM.HOME
    //retrieve page label
    this.translate.get(["PAGE_HOME", "PAGE_FULL_TEXT_SEARCH", "PAGE_CHANGE_PASSWORD", "PAGE_LOGOUT", "PAGE_FULL_TEXT_SEARCH_FULL", "PAGE_UPLOAD"]).subscribe(res => {
      // build menu items
      this.setMenuItems(res);
    });
  }

  private setMenuItems(res: any) {
    //set default page name as HOME
    this.pageName = res["PAGE_HOME"]
    if (this.isReferente || this.isCSE) {
      this.getMenuItemsReferente(res)
    } else {
      this.getMenuItemsAll(res);
    }

  }

  private getMenuItemsAll(res: any) {
    if (this.isAffidatario) {
      this.items = [
        {
          label: res["PAGE_HOME"],
          styleClass: "menu-item-label",
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.HOME;
            this.pageName = res["PAGE_HOME"];
          }
        },
        {
          label: res["PAGE_FULL_TEXT_SEARCH"],
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.FULL_TEXT_SEARCH;
            this.pageName = res["PAGE_FULL_TEXT_SEARCH_FULL"];
          }
        },
        {
          label: res["PAGE_UPLOAD"],
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.UPLOAD;
            this.pageName = res["PAGE_UPLOAD"];
          }
        },
        {
          label: res["PAGE_CHANGE_PASSWORD"],
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.CHANGE_PASSWORD;
            this.pageName = res["PAGE_CHANGE_PASSWORD"];
          }
        },
        {
          label: res["PAGE_LOGOUT"],
          command: () => {
            this.alertUtil.showConfirmationAlert("LBL_CONFIRM_LOGOUT", null, null, null, null, () => {
              this.onLogout.emit();
            });
          }
        }
      ]
    } else {
      this.items = [
        {
          label: res["PAGE_HOME"],
          styleClass: "menu-item-label",
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.HOME;
            this.pageName = res["PAGE_HOME"];
          }
        },
        {
          label: res["PAGE_FULL_TEXT_SEARCH"],
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.FULL_TEXT_SEARCH;
            this.pageName = res["PAGE_FULL_TEXT_SEARCH_FULL"];
          }
        },
        {
          label: res["PAGE_CHANGE_PASSWORD"],
          command: () => {
            this.currentPageEnum = Enum.PAGE_ENUM.CHANGE_PASSWORD;
            this.pageName = res["PAGE_CHANGE_PASSWORD"];
          }
        },
        {
          label: res["PAGE_LOGOUT"],
          command: () => {
            this.alertUtil.showConfirmationAlert("LBL_CONFIRM_LOGOUT", null, null, null, null, () => {
              this.onLogout.emit();
            });
          }
        }
      ];
    }
  }

  private getMenuItemsReferente(res: any) {
    this.items = [
      {
        label: res["PAGE_HOME"],
        styleClass: "menu-item-label",
        command: () => {
          this.currentPageEnum = Enum.PAGE_ENUM.HOME;
          this.pageName = res["PAGE_HOME"];
        }
      },
      {
        label: res["PAGE_CHANGE_PASSWORD"],
        command: () => {
          this.currentPageEnum = Enum.PAGE_ENUM.CHANGE_PASSWORD;
          this.pageName = res["PAGE_CHANGE_PASSWORD"];
        }
      },
      {
        label: res["PAGE_LOGOUT"],
        command: () => {
          this.alertUtil.showConfirmationAlert("LBL_CONFIRM_LOGOUT", null, null, null, null, () => {
            this.onLogout.emit();
          });
        }
      }
    ];
  }

  openManual(manualType: string) {
    //is production version if WS_BASE_URL points to regione calabria
    //let isProductionVersion: boolean = Constants.WS_BASE_URL.indexOf("calabria") > -1
    /* else {
      let uri = isProductionVersion ? "assets/manuale/ProtocolloLegalita_ManualeUtenteScan.pdf" : "assets/manuale/ProtocolloLegalita_ManualeUtenteScan_topnetwork.pdf"
      window.open(uri, "_blank")
    } */
    let uri = ""
    if (this.isEsecutore) {
      uri = "assets/manuale/Legalileo_ManualeUtente_ESECUTORE.pdf"
    } else if (this.isAggiudicatario) {
      uri = "assets/manuale/Legalileo_ManualeUtente_AGG.pdf"
    } else if (this.isAffidatario) {
      uri = "assets/manuale/Legalileo_ManualeUtente_StazioneAppaltante.pdf"
    }
    window.open(uri, "_blank")
  }

  getAllAllegatiAndCheckNonLetti() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.gestioneAllegatiService.getAllAllegati(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          let blinking: boolean = false
          let allegati = response.data
          allegati.forEach(allegato => {
            if (!allegato.DataLettura) {
              blinking = true
            }
          });
          if (blinking) {
            this.waitingForConnection = {
              "animation": "blinker 1.0s cubic-bezier(.5, 0, 1, 1) infinite alternate",
              "background-color": "red"
            }
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  onTabAllegatiSelected(event) {
    this.translate.get("MENU_ALLEGATI").subscribe(res => {
      if (event.originalEvent.toElement && event.originalEvent.toElement.innerText == res) { //tab allegati
        this.waitingForConnection = {}
      }
    })
  }

  openGDPR() {
    Loading.isLoading = true;

    let userCk: IUserCheck = {
      Username: localStorage.getItem(Constants.LS_USERNAME)
    };
    let reqBuilder = new RequestBuilder(userCk)

    this.loginService.checkGDPR(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else if (response.data) {
          this.openGDPR_PDF()
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
  openGDPR_PDF() {
    let uri = "assets/gdpr/CVN_Informativa LEGALILEO r1.pdf"
    window.open(uri, "_blank")
  }
}
